export const SAFE_LINK_ATTRIBUTES = {
  rel: 'noopener noreferrer',
};

export const EXTERNAL_LINK_ATTRIBUTES = {
  ...SAFE_LINK_ATTRIBUTES,
  target: '_blank',
};
